import { handleRequest } from "../utilities/requestHandler";

export const getProducts = () =>
    handleRequest("get","/products");

export const createProduct = (productData) =>
    handleRequest("post", "/products/create", productData);

export const updateProduct = (productId, productData) =>
    handleRequest("put", `/products/${productId}`, productData);

export const deleteProducts = (ids) =>
    handleRequest("post", "/products/delete", { ids });

export const uploadProductAssets = (formData) =>
    handleRequest("post", "/products/upload-assets", formData, { 'Content-Type': 'multipart/form-data' });
